<template>
  <div class="page-forget-password">
    <div class='form-block'>
      <p>{{$t('loginPage.forgetPassword')}}</p>
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="top"
      >
        <el-form-item :label="$t('loginPage.emailAddress')" prop="email" required style="margin-top:25px;">
          <el-input v-model='form.email'></el-input>
          <span class='tips'>{{$t('loginPage.emailTips')}}</span>
        </el-form-item>
        <el-form-item :label="$t('loginPage.verificationCode')" prop="verificationCode" style="margin-bottom:40px;">
          <div style="display:flex;align-items: center;">
            <el-input
              class="login-input"
              v-model="form.verificationCode"
              placeholder=""
              style="margin-right:15px;"
              @keyup.enter.native="buttonOk()"
              >
            </el-input>
            <img :src="verificationCodeUrl" style="width: 30%;margin-top:-10px;border:1px solid #DCDFE6;" @click="getLoginCode"/>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="footerBtnBox">
        <el-button size="small" @click="buttonCancel()">{{
          $t("button.cancel")
        }}</el-button>
        <el-button size="small" type="primary" @click="buttonOk()" :disabled='submitted'>{{
          $t("loginPage.findPassword")
        }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty } from "../utils/utils";
export default {
  data() {
    var emailValidator = (rule, value, callback) => {
      var regex = new RegExp(
        "^((^$)|(\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*))$"
      );
      if (isEmpty(value)) {
        callback(new Error(this.$t("loginPromptMessage.emailEmpty")));
      } else if (regex.test(value) == false) {
        callback(new Error(this.$t("loginPromptMessage.emailError")));
      } else {
        callback();
      }
    };
    return {
      submitted:false,
      rules:{
        email:[{validator:emailValidator}],
        verificationCode:[{required:true,message:this.$t('loginPromptMessage.verificacionCodeEmpty')}]
      },
      form:{
        email:'',
        verificationCode:''
      },
      verificationCodeUrl:'',
      verificationId:''
    }
  },
  created () {
    this.getLoginCode()
  },
  methods: {
    buttonCancel() {
      this.$router.push({
        name:'Login'
      })
    },
    buttonOk(){
      this.$refs.form.validate(valid=>{ 
        if(valid){
          this.submitted=true;
          const params={
            email:this.form.email,
            validateCode:this.form.verificationCode,
            validateCodeId:this.verificationId,
          }
          this.$httpList.forgetPassword(params).then(res=>{
            if(res.resultCode==1001){
              this.buttonCancel();
              this.$notify({
                message:this.$t('loginPage.jumpToEmail'),
                type:'success'
              })
            }
          }) .catch((err) => {
              const res=err.response;
              this.getLoginCode();
            }).finally(()=>{
            this.submitted=false;
          })
        }

      })
    },
    getLoginCode(){
      this.$httpList.getLoginCode(300).then(res=>{
        if(res.resultCode=='1001'){
          this.verificationCodeUrl=res.data.captcha;
          this.verificationId=res.data.id;
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.page-forget-password{
  height:100%;
  padding:5%;
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content: center;
  p{
    font-size:20px;
    font-weight:600;
    text-align:center;
  }
  .form-block{
    width:500px;
    box-sizing: border-box;
    box-shadow: 0px 2px 4px 0px rgba(187, 191, 196, 0.5);
    border:1px solid rgba(187, 191, 196, 0.5);
    border-radius: 10px;
    background:#fff;
    padding:30px;
    .title {
      margin-top: 20px;
      text-align: center;
      font-weight: 600;
      font-size:16px;
      color:#333333;
    }
    .tips{
      color:#ccc;
      line-height:24px;
      display:block;
    }
    .form {
      padding: 2vw;
    }
    .footerBtnBox {
      display: flex;
      justify-content: space-between;
      .el-button {
        border-radius: 8px !important;
      }
    }
  }
}
</style>